import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { forwardRef } from 'react';
import TextInput from './text-input';
var displayName = 'CurrencyInput';

var Prefix = function Prefix() {
  return /*#__PURE__*/React.createElement("span", null, "$");
};

export var CurrencyInput = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TextInput, _extends({
    placeholder: "0.00",
    Prefix: Prefix
  }, props, {
    type: "number",
    step: "any",
    ref: ref
  }));
});
CurrencyInput.displayName = displayName;
export default CurrencyInput;